import Vue from 'vue'
import App from './App.vue'
import router from '../src/router/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/css/main.css'
import '@/assets/fonts/font.css'
import axios from 'axios'
import VueAxios from "vue-axios";
 
Vue.use(VueAxios, axios)

Vue.config.productionTip = false
Vue.use(ElementUI);

// Vue.prototype.fileServer = "http://127.0.0.1:8080/api";  // 文件服务器
Vue.prototype.fileServer = "https://www.lucida.fund/api";  // 文件服务器 (生产环境)

Vue.prototype.request = axios.create({
  // baseURL: "http://127.0.0.1:8080/api",  // 本地环境
  baseURL: "https://www.lucida.fund/api",  // 生产环境
  timeout: 10000 // 10秒后超时
});

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
